<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm"
          style="margin-top: 20px">
          <el-col :xl="5" :lg="8" :md="12">
            <el-form-item label="产品名称：">
              <el-input size="medium" placeholder="请输入产品名称" minlength="2" maxlength="10" v-model="searchForm.NAME" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="{ span: 1, offset: 1 }" :lg="1" :md="1">
            <el-button size="medium" type="primary" @click="queryData">筛选</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" @click="addProduct(scope.row)">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryProductFun } from 'api/production';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      searchForm: {},
      submitArr: [],
    };
  },
  methods: {
    queryData() {
      const params = {
        PRODUCT_NAME: this.searchForm.NAME,
      };
      queryProductFun(params).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addProduct(row) {
      this.submitArr.push(row);
      let tmpArr = [];
      tmpArr = this.submitArr.map((item) => ({
        OP_CODE: item.PRODUCT_CODE, TYPE_UNIT: item.TYPE_UNIT, NAME: item.NAME, OP_RATE: '', FEE_RATE: '',
      }));
      sessionStorage.setItem('productArr', JSON.stringify(tmpArr));
      this.$message.show({ text: '添加成功', type: 'success' });
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/addProductionDetail.vue